'use client';

var TreeSelectAction;
(function (TreeSelectAction) {
    TreeSelectAction[TreeSelectAction["UPDATE_SELECTED_PARENT_ID"] = 0] = "UPDATE_SELECTED_PARENT_ID";
    TreeSelectAction[TreeSelectAction["UPDATE_SELECT_LEVEL"] = 1] = "UPDATE_SELECT_LEVEL";
    TreeSelectAction[TreeSelectAction["UPDATE_HISTORY"] = 2] = "UPDATE_HISTORY";
    TreeSelectAction[TreeSelectAction["UPDATE_SCROLLING_POSITION"] = 3] = "UPDATE_SCROLLING_POSITION";
})(TreeSelectAction || (TreeSelectAction = {}));

export { TreeSelectAction };
//# sourceMappingURL=types.js.map
